import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-f5aedfe6"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "head-logo"
};
const _hoisted_2 = {
  href: "/index.html"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "nav-list"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["href", "target"];

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bottom-line"
}, null, -1));

const _hoisted_9 = {
  class: "nav-item item-hide"
};
const _hoisted_10 = ["href", "target"];
const _hoisted_11 = {
  class: "head-btn"
};
const _hoisted_12 = {
  key: 0,
  class: "workbench"
};
const _hoisted_13 = {
  key: 0,
  src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/be58dd0e0cf14ca29324989fc7391fcb.png"
};
const _hoisted_14 = {
  key: 1,
  src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/2764788bf35d4da28898504c38b3a144.png"
};

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "工作台", -1));

const _hoisted_16 = {
  class: "workbench-content"
};
const _hoisted_17 = {
  key: 0,
  src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/02775dce51e34208bc0c1071c4b95229.png"
};
const _hoisted_18 = {
  class: "workbench-top"
};
const _hoisted_19 = {
  class: "user-info"
};

const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "您好,", -1));

const _hoisted_21 = {
  key: 0
};

const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "AI教学中心", -1));

const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/a2b5328c56e5495397e6d2e540e8cf83.png"
}, null, -1));

const _hoisted_24 = [_hoisted_22, _hoisted_23];
const _hoisted_25 = {
  class: "workbench-bottom"
};
const _hoisted_26 = ["onClick"];
const _hoisted_27 = ["src"];
const _hoisted_28 = {
  key: 0,
  class: "head-login"
};
const _hoisted_29 = ["href"];
const _hoisted_30 = {
  key: 1,
  class: "head-user"
};
const _hoisted_31 = {
  class: "avatar-box"
};
const _hoisted_32 = ["src"];
const _hoisted_33 = {
  class: "menu-btn"
};

const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon icon-admin"
}, null, -1));

const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "管理后台", -1));

const _hoisted_36 = [_hoisted_34, _hoisted_35];

const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "split-line"
}, null, -1));

const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon icon-account"
}, null, -1));

const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "账号设置", -1));

const _hoisted_40 = [_hoisted_38, _hoisted_39];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MoreFilled = _resolveComponent("MoreFilled");

  const _component_el_icon = _resolveComponent("el-icon");

  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

  const _component_el_dropdown = _resolveComponent("el-dropdown");

  const _component_el_scrollbar = _resolveComponent("el-scrollbar");

  const _component_el_popover = _resolveComponent("el-popover");

  return _openBlock(), _createElementBlock("div", {
    ref: "pride_tab_fixed",
    class: _normalizeClass(["header-container", {
      'header-home': $props.page == '首页' || !$data.isFixed,
      'header-default': $props.page != '首页' || $data.isFixed
    }])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("a", _hoisted_2, [$data.isFixed || $props.page != '首页' ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $data.headerBg
  }, null, 8, _hoisted_3)) : (_openBlock(), _createElementBlock("img", {
    key: 1,
    src: $data.logoUrl,
    alt: ""
  }, null, 8, _hoisted_4))])]), _createVNode(_component_el_scrollbar, {
    class: "nav-list-container"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.showNavList, item => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["nav-item", $data.pages == item.nav_name ? 'nav-active' : '']),
        key: item.id,
        onClick: $event => _ctx.handleMenuClick(item)
      }, [_createElementVNode("a", {
        href: item.target_url,
        target: item.target_type == 1 ? '_blank' : '_self'
      }, _toDisplayString(item.nav_name), 9, _hoisted_7), _hoisted_8], 10, _hoisted_6);
    }), 128)), $options.hideNavList.length > 0 ? (_openBlock(), _createBlock(_component_el_dropdown, {
      key: 0,
      "popper-class": "hidemenu_drop"
    }, {
      dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.hideNavList, hideItem => {
          return _openBlock(), _createBlock(_component_el_dropdown_item, {
            key: hideItem.id
          }, {
            default: _withCtx(() => [_createElementVNode("a", {
              href: hideItem.target_url,
              class: "noticenav",
              target: hideItem.target_type ? '_blank' : '_self'
            }, _toDisplayString(hideItem.nav_name), 9, _hoisted_10)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      })]),
      default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createElementVNode("a", null, [_createVNode(_component_el_icon, {
        class: "more_icon"
      }, {
        default: _withCtx(() => [_createVNode(_component_MoreFilled)]),
        _: 1
      })])])]),
      _: 1
    })) : _createCommentVNode("", true)])]),
    _: 1
  }), _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_popover, {
    "popper-class": "workbench-popper",
    "show-arrow": false,
    offset: 12,
    width: 328,
    placement: "bottom-end"
  }, {
    reference: _withCtx(() => [$data.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_12, [$data.isFixed || $props.page != '首页' ? (_openBlock(), _createElementBlock("img", _hoisted_13)) : (_openBlock(), _createElementBlock("img", _hoisted_14)), _hoisted_15])) : _createCommentVNode("", true)]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", {
      class: "userole-troggle",
      onClick: _cache[0] || (_cache[0] = $event => $options.toggleShowRole())
    }, [_createElementVNode("span", null, _toDisplayString($data.userRoleList[$data.currentRole]), 1), $data.userRole < 3 && $data.userRole > 0 ? (_openBlock(), _createElementBlock("img", _hoisted_17)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_hoisted_20, _createElementVNode("div", null, [_createTextVNode(_toDisplayString($data.userInfo && $data.userInfo.realname) + " ", 1), $data.userRole > 1 ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString($data.userNameList[$data.userRole]), 1)) : _createCommentVNode("", true)])]), _createElementVNode("div", {
      class: "main-btn",
      onClick: _cache[1] || (_cache[1] = $event => $options.handleOpenUrl($data.onlineUrl))
    }, _hoisted_24)]), _createElementVNode("div", _hoisted_25, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.menuList, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: "workbench-item",
        onClick: $event => $options.handleOpenUrl(item.jump_url)
      }, [_createElementVNode("img", {
        src: item.icon_url
      }, null, 8, _hoisted_27), _createElementVNode("span", null, _toDisplayString(item.app_name), 1)], 8, _hoisted_26);
    }), 256))])])]),
    _: 1
  }), !$data.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createElementVNode("a", {
    href: $options.getLoginUrl(),
    referrerPolicy: "no-referrer"
  }, "登录", 8, _hoisted_29)])) : _createCommentVNode("", true), $data.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_createVNode(_component_el_popover, {
    "popper-class": "user-info-popper",
    placement: "bottom-end",
    offset: 12,
    width: 212,
    "show-arrow": false
  }, {
    reference: _withCtx(() => [_createElementVNode("div", _hoisted_31, [_createElementVNode("img", {
      class: "avatar",
      src: $data.userInfo.avatar ? $data.userInfo.avatar : require('../../assets/images/user_icon.png')
    }, null, 8, _hoisted_32)])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_33, [_createElementVNode("div", {
      class: "menu-btn-item",
      onClick: _cache[2] || (_cache[2] = (...args) => $options.goAdminPage && $options.goAdminPage(...args))
    }, _hoisted_36), _hoisted_37, _createElementVNode("div", {
      class: "menu-btn-item",
      onClick: _cache[3] || (_cache[3] = (...args) => $options.goAccountSet && $options.goAccountSet(...args))
    }, _hoisted_40)]), _createElementVNode("div", {
      class: "menu-bottom-btn",
      onClick: _cache[4] || (_cache[4] = (...args) => $options.handleExit && $options.handleExit(...args))
    }, "退出登录")]),
    _: 1
  })])) : _createCommentVNode("", true)])], 2);
}